import * as _ from "lodash";
import http from "../constant/api";

export const profileShorthandService = {
  listProfileShorthandByProfileId: async (profileId, search) => {
    const result = await http.get(
      `/api/profile-shorthand/list/profile-id/${profileId}?search=${search}`
    );

    return result;
  },
  addProfileShorthand: async (data) => {
    const result = await http.post(`/api/profile-shorthand/add`, data);

    return result;
  },
  editProfileShorthand: async (id, data) => {
    const result = await http.put(`/api/profile-shorthand/${id}/edit`, data);

    return result;
  },
  removeProfileShorthand: async (id) => {
    const result = await http.delete(`/api/profile-shorthand/${id}/remove`);

    return result;
  },
};
